import React from 'react';

import { Button, Grid, IconButton, makeStyles, Typography } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';

import { DCM, iconSetup } from '../../models/Resource';

const useStyles = makeStyles(() => {
  return {
    additionalFileContainer: {
      alignItems: 'center',
      backgroundColor: '#F5F5F5',
      borderRadius: '4px',
      display: 'flex',
      gap: '16px',
      justifyContent: 'space-between',
      padding: '12px 16px',
    },
    additionalFileName: {
      color: '#172B4D',
      fontSize: '14px',
      lineHeight: '18px',
      maxWidth: '250px',
      wordBreak: 'break-all',
    },
    additionalFileTitleContainer: {
      alignItems: 'center',
      display: 'flex',
    },
    additionalIconImage: {
      height: '100%',
      marginRight: '12px',
      width: '24px',
    },
    statsContainer: {
      background: '#F5F5F5',
      borderRadius: '10px',
      fontSize: '11px',
      padding: '7px 14px',
      textAlign: 'left',
    },
    statsText: {
      fontSize: '11px',
      fontWeight: 'bold',
    },
  };
});

export default ({ onRemoveAdditionalFiles, onOpenAdditionalFilesDialog, additionalFiles }) => {
  const classes = useStyles();

  const handleRemoveAdditionalFiles = (index) => {
    if (onRemoveAdditionalFiles) onRemoveAdditionalFiles(index);
  };

  const handleOpenAdditionalFilesDialog = () => {
    if (onOpenAdditionalFilesDialog) onOpenAdditionalFilesDialog();
  };

  const renderAdditionalFiles = () => {
    if (additionalFiles?.length) {
      const renderedAdditionalFiles = additionalFiles.map((file, idx) => {
        let name = file.files[0]?.name;
        const selectedIcon = iconSetup[file.type] || iconSetup.document;

        if (file.type === DCM) name = file.files.find((additionalFile) => additionalFile.type === 'application/dicom')?.name || name;

        return (
          <Grid container className={classes.additionalFileContainer} key={file.key} justifyContent="flex-start" alignItems="center" wrap="nowrap">
            <div className={classes.additionalFileTitleContainer}>
              <img src={selectedIcon} className={classes.additionalIconImage} alt="" />
              <Typography className={classes.additionalFilesName} style={{ lineBreak: 'anywhere', textAlign: 'left', wordWrap: 'break-word' }}>
                {name} - {file.type}
              </Typography>
            </div>
            <IconButton size="small" color="primary" onClick={() => handleRemoveAdditionalFiles(idx)}>
              <CloseIcon fontSize="small" />
            </IconButton>
          </Grid>
        );
      });

      return (
        <>
          {renderedAdditionalFiles}
          <Grid container justifyContent="flex-start" className="mt-1">
            <Button variant="outlined" color="primary" component="span" onClick={handleOpenAdditionalFilesDialog}>
              Add Additional File
            </Button>
          </Grid>
        </>
      );
    }

    return (
      <Grid container justifyContent="flex-start">
        <Button onClick={handleOpenAdditionalFilesDialog} variant="outlined" component="span" color="primary">
          Add Additional File
        </Button>
      </Grid>
    );
  };

  return (
    <Grid container>
      <Grid item xs={12} md={6} style={{ display: 'flex', flexDirection: 'column', gap: '16px', height: '100%', padding: '0 3rem' }}>
        <Typography className="field-label text-left mt-1">Additional Files</Typography>
        {renderAdditionalFiles()}
      </Grid>
    </Grid>
  );
};
